import { c as _c } from "react/compiler-runtime";
import Button from '@precis-digital/kurama/Button';
import Link from '@precis-digital/kurama/Link';
import Typography from '@precis-digital/kurama/Typography';
import React, { useState } from 'react';
import { type MemberRole } from 'shared/api/clients';
import { AvatarWithLabel } from 'shared/components/AvatarWithLabel';
import { useTranslation } from 'shared/translations';
import { ensureAbsoluteUrl } from 'shared/utils/stringFormatter';
import InviteNewMembersPopup from '../Popup/InviteNewMembersPopup';
import { StyledAvatarContainer } from './styles';
import StandaloneAvatarUpload from 'shared/components/AvatarUpload/StandaloneAvatarUpload';
interface AvatarContainerProps {
  name: string;
  url: string;
  avatarUrl?: string;
  id: number;
  role: MemberRole;
  uploadAvatarProps: {
    uploadAvatar: (file: File) => Promise<void>;
    isUploading: boolean;
    isUploadSuccess: boolean;
  };
}
const AvatarContainer = props => {
  const $ = _c(25);
  const [isOpen, setIsOpen] = useState(false);
  const {
    name,
    url,
    avatarUrl,
    role,
    id,
    uploadAvatarProps
  } = props;
  let t0;
  if ($[0] !== avatarUrl || $[1] !== id || $[2] !== name || $[3] !== url) {
    t0 = {
      id,
      name,
      url,
      avatarUrl
    };
    $[0] = avatarUrl;
    $[1] = id;
    $[2] = name;
    $[3] = url;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const client = t0;
  const {
    t
  } = useTranslation("workspace");
  let t1;
  if ($[5] !== client || $[6] !== role || $[7] !== uploadAvatarProps) {
    t1 = role === "admin" ? <StandaloneAvatarUpload uploadAvatarProps={uploadAvatarProps} client={client} /> : <AvatarWithLabel size="large" client={client} />;
    $[5] = client;
    $[6] = role;
    $[7] = uploadAvatarProps;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== name) {
    t2 = <Typography variant="h2">{name}</Typography>;
    $[9] = name;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== url) {
    t3 = ensureAbsoluteUrl(url);
    $[11] = url;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t3 || $[14] !== url) {
    t4 = <Link variant="body3" href={t3} target="_blank" rel="noreferrer">{url}</Link>;
    $[13] = t3;
    $[14] = url;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== isOpen || $[17] !== role || $[18] !== t) {
    t5 = role === "editor" ? <><Button scheme="light" variant="filled" onClick={() => {
        setIsOpen(true);
      }}>{t("buttons.inviteMembers")}</Button><InviteNewMembersPopup open={isOpen} onClose={() => {
        setIsOpen(false);
      }} /></> : null;
    $[16] = isOpen;
    $[17] = role;
    $[18] = t;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t1 || $[21] !== t2 || $[22] !== t4 || $[23] !== t5) {
    t6 = <StyledAvatarContainer>{t1}{t2}{t4}{t5}</StyledAvatarContainer>;
    $[20] = t1;
    $[21] = t2;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};
export default AvatarContainer;